<style>
video::-webkit-media-controls-enclosure {        display: none !important;    }

/*video默认全屏按钮*/
    video::-webkit-media-controls-fullscreen-button{ display: none !important; }
 
    /*video默认aduio音量按钮*/
    video::-webkit-media-controls-mute-button { display: none !important;}
 
    /*video默认setting按钮*/
    video::-internal-media-controls-overflow-button{ display: none !important;}
 
    /*腾讯云点播禁用firefox全屏、设置按钮*/
    .trump-button[sub-component="fullscreen_btn"],.trump-button[now="fullscreen"]{ display:none!important;}
    .trump-button[sub-component="setting"]{ display:none !important;}
 
/*禁用video的controls（要慎重！不要轻易隐藏掉，会导致点击视频不能播放）*/
video::-webkit-media-controls {
  display:none !important;
}
.xf_max{
	position: relative;
}
.countDown{
	/* position: absolute;
	top: 10px;
    right: 10px;
	z-index: 10; */
	/* border: 1px solid #e93323; */
	color: #e93323;
    /* border-radius: 50%; */
    padding: 8px;
}
.countDown.isWX{
	/* position: absolute;
	top: 10px;
	right: 10px;
	z-index: 10;
	border: 1px solid #e93323;
	border-radius: 50%; */
}
</style>
<template>
    <div>
		<div class="xf_max" >
			<div  v-bind:class="[isWX ? 'wx' : 'nwx', 'countDown']" v-if="countDownTime != -1 && countDownTime!=0">{{countDownTime}}秒后获得{{video.money}}金币</div>
			<div v-bind:class="[isWX ? 'wx' : 'nwx', 'countDown']" v-if="msg">{{msg}}</div>
			<div class="xf_val">
				<video ref="video" controlsList="nofullscreen nodownload noremote footbar"  :src="video.video_url"
				  @timeupdate="timeupdate" @ended="ended" x5-video-player-type="h5"
				  style="width: 100%; height: 100%;"></video>
			<!-- x5-video-player-type="h5" -->
			</div>
			<!-- <div class="xf_tet">
				<h3>{{video.param}}</h3> 
			</div> -->
			
		</div>

    </div>
</template>
<script>
	import "@assets/css/swiper.min.css";
	import {
		getVideoDetail,
		getVideoMoney,
		getUser
	} from "@api/public";
	import Loading from "@components/Loading";
	export default {
		name: "VideoDetail",
		components: {
			Loading
		},
		props: {},
		data: function() {
			return {
				video:{},
				countDownTime:-1,
				currentTime:0,
				last:0,
				getart: {
					cid: this.$route.query.id
				},
				banner: {
					id: this.$route.query.id
				},
				banners: '', 
				getarts: {},
				tater:{},
				animate: false,
			};
		}, 
		watch: {
		  $route(to) {
		  //    this.articleBanner();
			 // this.articleHotList();
			 // this.created()
		  }
		},
		mounted: function() {
			this.updateTitle()
			
		},
		created: function () {
			// setInterval (this.showMarquee, 2000) 
			this.getUserInfo()
			var user = this.$store.state.app.userInfo
			console.log(this.$store.state)
			console.log(user)
			// if(!user){
			// 	this.$router.push({
			// 		path:'/login'
			// 	})
			// }
			// this.isWX = this.getIsWxClient()
		},
		methods: {
			getIsWxClient () {
				var ua = navigator.userAgent.toLowerCase();
				if (ua.match(/MicroMessenger/i) == "micromessenger") {
					return true;
				}
				return false;
			},
			getUserInfo(){
				// this.getDetail()
				// return
				getUser({}).then(res=>{
					this.getDetail()
				},error=>{
					this.getDetail()
				})
			},
			getDetail(){
				getVideoDetail({video_id:this.$route.query.id}).then(res=>{
					console.log(res)
					if(res.data){
						this.video = res.data.data
						this.uid = res.data.uid
						this.video.video_url = 'http://www.yilongshanghui.com'+this.video.video_url
						this.$nextTick(()=>{
							this.$refs.video.play()
						})
						this.countDownTime = Number(this.video.leight_time)
						setInterval(()=>{
							this.countDownTime = this.countDownTime < 0 ? 0 : this.countDownTime - 1
						},1000)
						console.log(Number(this.video.leight_time));
						var num = Number(this.video.leight_time)*1000
						setTimeout(()=> {
							this.getMoney()
						}, num);
					}
				})
			},
			timeupdate(){
				var video = this.$refs.video
				var current = video.currentTime;
				this.currentTime = video.currentTime
				if (current - this.last > 2) {
				  video.currentTime = this.last;
				  this.$refs.video.play()
				} else {
					
				  this.last = current;
				}
			},
			ended(){
				var video = this.$refs.video
				if(Number(this.video.leight_time) - this.last > 2){
					video.currentTime = this.last;
					this.$refs.video.play()
					return
				}
				// this.getMoney()
			},
			getMoney(){
				var user = this.$store.state.app.userInfo
				// console.log(user)
				// if(!user){
				// 	this.$router.push({
				// 		path:'/login'
				// 	})
				// }
				// return
				getVideoMoney({uid:this.uid,video_id:this.$route.query.id}).then(res=>{
					this.countDownTime = -1
					this.msg = `已获得${this.video.money}金币`
				})
			},
			updateTitle() {
			  // document.title = this.title || this.titles;
			},
		

		}
	};

</script>
